<template>
  <v-container>
    <nav class="navbar navbar-inverse navbar-fixed-top style">
      <div class="container-fluid col-sm-12 col-md-12 col-xs-12">
        <div class="navbar-header">
          <v-btn class="hidden-md-and-up button-personal" icon @click="changeButton()">
            <v-icon>list</v-icon>
          </v-btn>
          <img :src="img1" height="55" />
        </div>
      </div>
    </nav>
    <v-layout row>
      <v-flex md2 lg2 sm0 xs0>
        <v-navigation-drawer v-if="mini" stateless touchless value="true" fixed>
          <v-list>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>home</v-icon>
              </v-list-tile-action>

              <v-list-tile-title>Autoevaluación</v-list-tile-title>
            </v-list-tile>

            <!--  <v-list-tile
              v-if="this.$session.getAll().userType == 'postgradodca' || this.$session.getAll().userType == 'prorrector' || this.$session.getAll().userType == 'vipo'"
              :to="{name:'ccm'}"
            >
              <v-list-tile-title>Cambiar carrera</v-list-tile-title>
            </v-list-tile>
            -->
            <v-list-group>
              <template v-slot:activator>
                <v-list-tile @click="redirect('intro1')">
                  <v-list-tile-title>Autoevaluación</v-list-tile-title>
                </v-list-tile>
              </template>

              <v-list-group no-action sub-group>
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Documentos Autoevaluación</v-list-tile-title>
                  </v-list-tile>
                </template>
                <v-list-tile
                  :to="{name:'documentosArea', params: { id: 14 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Informe de Autoevaluación'"></v-list-tile-title>
                </v-list-tile>

                <v-list-tile
                  :to="{name:'documentosArea', params: { id: 8 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Gestión'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'documentosArea', params: { id: 9 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Pregrado'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'documentosArea', params: { id: 10 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Postgrado'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'documentosArea', params: { id: 11 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Investigación'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'documentosArea', params: { id: 12 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Vinculación con el medio'"></v-list-tile-title>
                </v-list-tile>

                <v-list-tile
                  :to="{name:'documentosArea', params: { id: 13 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Otros'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>

              <v-list-group no-action sub-group>
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Acreditación 2014</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile
                  :to="{name:'documentosArea', params: { id: 15 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Documentos 2014'"></v-list-tile-title>
                </v-list-tile>

                 <v-list-tile
                  :to="{name:'avance2014'}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Avances resumen'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>

              <v-list-group no-action sub-group>
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Indicadores previos</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile
                  :to="{name:'indicadoresEvidencia', params: { id: 1 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Gestión'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'indicadoresEvidencia', params: { id:2 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Pregrado'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'indicadoresEvidencia', params: { id: 3 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Postgrado'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'indicadoresEvidencia', params: { id: 4 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Investigación'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'indicadoresEvidencia', params: { id: 5 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Vinculación con el medio'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>

              <v-list-group no-action sub-group>
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Etapas Acreditación</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile
                  :to="{name:'documentos', params: { id: 1 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Inicio de Proceso'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'documentos', params: { id: 2 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Designación de Pares'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'documentos', params: { id: 3 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Programa de Visita'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'documentos', params: { id: 4 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Evaluación Externa'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'documentos', params: { id: 5 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Observaciones Evaluacion externa'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'documentos', params: { id: 6 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Comunicación Decisión'"></v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  :to="{name:'documentos', params: { id: 7 }}"
                  active-class="fix-position"
                >
                  <v-list-tile-title v-text="'Recurso de Reposición'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>

              <v-list-group no-action sub-group>
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Plan de mejoramiento</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-group no-action sub-group class="pull-subgrupo">
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-title>Gestión</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <v-list-tile :to="{name:'d1P', params: { id: 1 }}" active-class="fix-position">
                    <v-list-tile-title v-text="'Definición de Acciones'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'indicadores', params: { id: 1 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Definición de indicadores'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile :to="{name:'hitos'}" active-class="fix-position">
                    <v-list-tile-title v-text="'Etapa de Seguimiento y Gestión'"></v-list-tile-title>
                  </v-list-tile>
                </v-list-group>

                <v-list-group no-action sub-group class="pull-subgrupo">
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-title>Pregrado</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <v-list-tile :to="{name:'d1P', params: { id: 2 }}" active-class="fix-position">
                    <v-list-tile-title v-text="'Definición de Acciones'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'indicadores', params: { id: 2 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Definición de indicadores'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile :to="{name:'hitos'}" active-class="fix-position">
                    <v-list-tile-title v-text="'Etapa de Seguimiento y Gestión'"></v-list-tile-title>
                  </v-list-tile>
                </v-list-group>

                <v-list-group no-action sub-group class="pull-subgrupo">
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-title>Postgrado</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <v-list-tile :to="{name:'d1P', params: { id: 3 }}" active-class="fix-position">
                    <v-list-tile-title v-text="'Definición de Acciones'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'indicadores', params: { id: 3 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Definición de indicadores'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile :to="{name:'hitos'}" active-class="fix-position">
                    <v-list-tile-title v-text="'Etapa de Seguimiento y Gestión'"></v-list-tile-title>
                  </v-list-tile>
                </v-list-group>

                <v-list-group no-action sub-group class="pull-subgrupo">
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-title>Investigación</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <v-list-tile :to="{name:'d1P', params: { id: 4 }}" active-class="fix-position">
                    <v-list-tile-title v-text="'Definición de Acciones'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'indicadores', params: { id: 4 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Definición de indicadores'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile :to="{name:'hitos'}" active-class="fix-position">
                    <v-list-tile-title v-text="'Etapa de Seguimiento y Gestión'"></v-list-tile-title>
                  </v-list-tile>
                </v-list-group>

                <v-list-group no-action sub-group class="pull-subgrupo">
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-title>Vinculación con el medio</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <v-list-tile :to="{name:'d1P', params: { id: 5 }}" active-class="fix-position">
                    <v-list-tile-title v-text="'Definición de Acciones'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    :to="{name:'indicadores', params: { id: 5 }}"
                    active-class="fix-position"
                  >
                    <v-list-tile-title v-text="'Definición de indicadores'"></v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile :to="{name:'hitos'}" active-class="fix-position">
                    <v-list-tile-title v-text="'Etapa de Seguimiento y Gestión'"></v-list-tile-title>
                  </v-list-tile>
                </v-list-group>
              </v-list-group>

              <!--  <v-list-group
                no-action
                sub-group
                v-if="etapa.etapa4Dca || this.$session.getAll().userType == 'postgradodca' || this.$session.getAll().userType == 'vipo'"
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Revisión DCA</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile :to="{name:'documentos45'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Documentación'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>-->

              <!-- <v-list-group
                no-action
                sub-group
                v-if="etapa.etapa5Dca || this.$session.getAll().userType == 'postgradodca' || this.$session.getAll().userType == 'vipo'"
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Acta y aprobación</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-list-tile :to="{name:'documentosActa'}" active-class="fix-position">
                  <v-list-tile-title v-text="'Acta y aprobación'"></v-list-tile-title>
                </v-list-tile>
              </v-list-group>-->
            </v-list-group>

            <v-list-tile @click="logout()">
              <v-list-tile-action>
                <v-icon>arrow_back</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Cerrar Sesión</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
      <!-- lado derecho del contenido -->
      <v-flex md10 sm12 xs12>
        <div class="container">
          <router-view></router-view>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
//import Test from './Test'
//import Form from './Form'
//import Criterio from './Criterio'
import icono from "../../assets/LOGO USACH.png";
export default {
  type: "",
  name: "Sidebar",
  props: ["data"],
  components: {
    //Test,
    //Form,
    //Criterio,
  },

  data() {
    return {
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      etapa: "",
      criterios: [
        "Matrícula nueva",
        "Vacantes ofrecidas",
        "Caracterización estudiantes",
        "Retención primer año",
        "Retención total",
        "Tasa de egreso",
        "Tasa de titulación",
        "Titulación oportuna",
        "Tiempo real de titulación",
        "Empleabilidad",
        "Inserción ocupacional"
      ],
      on: false,
      esMayor: "",
      drawer: true,
      drawerRight: true,
      right: true,
      left: null,
      test: "hidden-sm-and-down",
      img1: icono,
      admins: [
        ["Management", "people_outline"],
        ["Settings", "settings"]
      ],
      cruds: [
        ["Create", "add"],
        ["Read", "insert_drive_file"],
        ["Update", "update"],
        ["Delete", "delete"]
      ],
      mini: true,
      drawer: true
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      if (this.$route.fullPath == "/introDca") this.initObservacionGral();
    }
  },

  created() {
    //console.log(this.$session.getAll().userType);
    this.type = this.$session.getAll().userType;
    this.esMayor = this.$session.getAll().ccData.esMayor;
    this.initObservacionGral();
  },
  methods: {
    initObservacionGral() {
      axios
        .get(
          process.env.ROOT_API +
            "/etapa/etapaUsuario?idPostgrado=" +
            this.$session.getAll().ccData.id,
          this.auth
        )
        .then(response => {
          //console.log("ANEXOS");
          //console.log(response.data);
          this.etapa = response.data;
        })
        .catch(error => {
          //console.log("ERROR ANEXOS");
          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },
    closeBar() {
      this.mini = false;
    },
    openBar() {
      this.mini = true;
    },
    changeButton() {
      //console.log("kjashdkjaHSDK");
      if (this.mini == false) {
        this.openBar();
      } else {
        this.closeBar();
      }
    },
    redirect(index) {
      this.$router.push({ name: index });
    },

    logout() {
      this.$session.destroy();
      this.$router.push("/");
    }
  }
};
</script>

<style >
.pull-subgrupo {
  padding-left: 5% !important;
}
.v-navigation-drawer--fixed {
  padding-top: 70px;
  padding-bottom: 50px;
  display: block;
  left: 0;
  max-width: 250px !important;
  overflow-y: auto;
  overflow-x: hidden;
  pointer-events: auto;
  top: 0;
  will-change: transform;
  z-index: 3;
  transition-delay: 2s;
}

.container-pro {
  align-items: left;
  margin-top: 70px;
  padding-bottom: 50px;
  left: 0;
  z-index: 6;
  position: fixed;
}

.button-personal {
  align-self: left;
}

.theme--light.v-navigation-drawer {
  background-color: #4376a2 !important;
}

.v-list__group__header--active .v-list__group__header__prepend-icon .v-icon {
  color: #90d2f8 !important;
}

.theme--light.v-icon {
  color: #90d2f8 !important;
}

.primary {
  background-color: #273039 !important;
}

.style {
  background: white !important;
  border-top: 3px solid #5dabd8 !important;
  border-bottom: 7px solid #b1b1b1 !important;
  background-color: #1c345d !important;
  height: 70px;
}

.img-style {
  text-align: right;
}

.fix-position {
  background: #80b8d8;
  text-decoration-line: none !important;
  text-decoration: none !important;
}

.pading-group {
  padding-left: 25px !important;
}
</style>



<style scoped>
.v-list__tile__title {
  color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/template/SideBar.vue